/**
 * This is a sample file that should be replaced with the actual translation.
 *
 * Checkout https://github.com/bpmn-io/bpmn-js-i18n for a list of available
 * translations and labels to translate.
 */
export default {
  // Labels
  'Append': 'افزودن',
  'Append Intermediate/Boundary Event': 'افزودن رویداد میانی یا مرزی',
  'TextAnnotation': 'یادداشت',
  'Append Gateway': 'افزودن دورازه',
  'Activate the global connect tool': 'Globales Verbindungswerkzeug aktivieren',
  'Append {type}': '{type} افزودن',
  'Add Lane above': 'افزودن مسیر در بالا',
  'Divide into two Lanes': 'تقسیم به دو مسیر',
  'Divide into three Lanes': 'تقسیم به سه مسیر',
  'Add Lane below': 'افزودن مسیر در پایین',
  'Append compensation activity': 'افزودن فعالیت جبرانی',
  'Change type': 'تغییر نوع',
  'Connect using Association': 'اتصال وابسته',
  'Connect using Sequence/MessageFlow or Association': 'اتصال وابسته یا جریان پیام',
  'Connect using DataInputAssociation': 'اتصال داده وابسته',
  'Remove': 'حذف',
  'Activate the hand tool': 'ابزار دست',
  'Activate the lasso tool': 'ابزار انتخاب',
  'Activate the create/remove space tool': 'حذف یا ایجاد ابزار فضا',
  'Create expanded SubProcess': 'ایجاد زیر فرآیند گسترده',
  'Create IntermediateThrowEvent/BoundaryEvent': 'ایجاد رویداد میانی یا مرزی',
  'Create Pool/Participant': 'ایجاد مسیر یا شرکت کننده',
  'Parallel Multi Instance': 'چند نمونه موازی',
  'Sequential Multi Instance': 'جند نمونه متوالی',
  'Loop': 'حلقه',
  'Ad-hoc': 'Ad-hoc',
  'Create {type}': '{type} ایجاد',
  'Task': 'وظیفه',
  'Send Task': 'ارسال وظیفه',
  'Receive Task': 'دریافت وظیفه',
  'User Task': 'وظیفه کاربر',
  'Manual Task': 'وظیفه دستی',
  'Business Rule Task': 'وظیفه تصمیم',
  'Service Task': 'وظیفه سرویس',
  'Script Task': 'وظیفه کد',
  'Call Activity': 'اجرای فعالیت',
  'Sub Process (collapsed)': 'زیر فرآیند بسته',
  'Start Event': 'رویداد شروع',
  'Intermediate Throw Event': 'پرتاب رویداد میانی',
  'End Event': 'رویداد پایانی',
  'Message Start Event': 'رویداد شروع (پیام)',
  'Timer Start Event': 'رویداد شروع (زمان)',
  'Conditional Start Event': 'رویداد شروع (شرط)',
  'Signal Start Event': 'رویداد شروع (سیگنال)',
  'Error Start Event': 'رویداد شروع (خطا)',
  'Escalation Start Event': 'رویداد شروع (تشدید)',
  'Compensation Start Event': 'رویداد شروع (جبرانی)',
  'Message Start Event (non-interrupting)': 'رویداد پیام مرزی (بدون وقفه)',
  'Timer Start Event (non-interrupting)': 'رویداد زمانی مرزی (بدون وقفه)',
  'Conditional Start Event (non-interrupting)': 'رویداد شرطی مرزی (بدون وقفه)',
  'Signal Start Event (non-interrupting)': 'رویداد سیگنال مرزی (بدون وقفه)',
  'Escalation Start Event (non-interrupting)': 'رویداد تشدید مرزی (بدون وقفه)',
  'Message Intermediate Catch Event': 'گرفتن رویداد پیام میانی',
  'Message Intermediate Throw Event': 'پرتاب رویداد پیام میانی',
  'Timer Intermediate Catch Event': 'گرفتن رویداد زمانی میانی',
  'Escalation Intermediate Throw Event': 'پرتاب رویداد تشدید میانی',
  'Conditional Intermediate Catch Event': 'گرفتن رویداد شرطی میانی',
  'Link Intermediate Catch Event': 'گرفتن رویداد پیوند میانی',
  'Link Intermediate Throw Event': 'پرتاب رویداد پیوند میانی',
  'Compensation Intermediate Throw Event': 'پرتاب رویداد جبرانی میانی',
  'Signal Intermediate Catch Event': 'گرفتن رویداد سیگنال میانی',
  'Signal Intermediate Throw Event': 'پرتاب رویداد سیگنال میانی',
  'Message End Event': 'رویداد پیام پایانی',
  'Escalation End Event': 'رویداد تشدید پایانی',
  'Error End Event': 'رویداد خطای پایانی',
  'Cancel End Event': 'رویداد انصراف پایانی',
  'Compensation End Event': 'رویداد جبرانی پایانی',
  'Signal End Event': 'رویداد سیگنال پایانی',
  'Terminate End Event': 'رویداد اتمام',
  'Message Boundary Event': 'رویداد پیام مرزی',
  'Message Boundary Event (non-interrupting)': 'رویداد پیام مرزی (بدون وقفه)',
  'Timer Boundary Event': 'رویداد زمانی مرزی',
  'Timer Boundary Event (non-interrupting)': 'رویداد زمانی مرزی (بدون وقفه)',
  'Escalation Boundary Event': 'رویداد تشدید مرزی',
  'Escalation Boundary Event (non-interrupting)': 'رویداد تشدید مرزی (بدون وقفه)',
  'Conditional Boundary Event': 'رویداد شرطی مرزی',
  'Conditional Boundary Event (non-interrupting)': 'رویداد شرطی مرزی (بدون وقفه)',
  'Error Boundary Event': 'رویداد خطا مرزی',
  'Cancel Boundary Event': 'رویداد انصراف مرزی',
  'Signal Boundary Event': 'رویداد سیگنال مرزی',
  'Signal Boundary Event (non-interrupting)': 'رویداد سیگنال مرزی (برون وقفه)',
  'Compensation Boundary Event': 'رویداد جبرانی مرزی',
  'Exclusive Gateway': 'دروازه تک خطی',
  'Parallel Gateway': 'دروازه موازی',
  'Inclusive Gateway': 'دروازه مشتمل',
  'Complex Gateway': 'دروازه مجتمع',
  'Event based Gateway': 'دروازه رویداد محور',
  'Transaction': 'تراکنش',
  'Sub Process': 'زیر فرآیند',
  'Event Sub Process': 'رویداد زیر فرآیند',
  'Collapsed Pool': 'بستن دسته',
  'Expanded Pool': 'بازکردن دسته',
  'Element Settings': 'تنظیمات',
  'Sub Process (expanded)': 'زیرفرآیند گسترده',

  'EndEvent': 'رویداد پایانی',

  // Errors
  'no parent for {element} in {parent}': 'kein Eltern-Element für {element} in {parent}',
  'no shape type specified': 'kein Typ der Form angegeben',
  'flow elements must be children of pools/participants': 'Fluss-Elemente müssen Kinder von Pools/Teilnehmern sein',
  'out of bounds release': 'außerhalb der Grenzen Release',
  'more than {count} child lanes': 'mehr als {count} Lane-Kinder',
  'element required': 'Element benötigt',
  'diagram not part of bpmn:Definitions': 'Prozessmodell ist nicht Teil von bpmn:Definitions',
  'no diagram to display': 'kein Prozessmodell',
  'no process or collaboration to display': 'kein Prozess/Kollaboration',
  'element {element} referenced by {referenced}#{property} not yet drawn': 'von {referenced}#{property} referenziertes Element {element} noch nicht gezeichnet',
  'already rendered {element}': '{element} bereits gerendert',
  'failed to import {element}': '{element} konnte nicht importiert werden'
};
